import { useTranslation } from 'react-i18next';

import { Card } from '../../components/Card';

export function AlreadyConsentedState() {
  const { t } = useTranslation();
  return (
    <Card>
      <div className="state-icon info" aria-hidden="true">
        ✓
      </div>
      <h1>{t('alreadyConsented.title')}</h1>
      <p>{t('alreadyConsented.body')}</p>
    </Card>
  );
}
